// extracted by mini-css-extract-plugin
export default {"LikeControl__btn":"ir_a"};